import React, { useEffect, useRef, useState } from 'react';
import Backdrop from '@material-ui/core/Backdrop';
// import './InspectionEdit.css';
import './cardpage.css';
import Select from 'react-select';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import {
  Badge,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';
import numeral from 'numeral';
import moment from 'moment';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import axios from '../axios';
import Button1 from 'reactstrap/lib/Button';
import { useHistory } from 'react-router-dom';
import { useStateValue } from '../StateProvider';
import Spinner from 'react-spinkit';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
  },
}));

function PoStatusView(props) {
  const history = useHistory();
  const pages = [
    10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
    600, 700, 800, 900, 1000,
  ];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);
  const [fromdatee, setfromdatee] = useState('');
  const [StatusFilter, setStatusFilter] = useState({ label: 'Pending', value: 'Pending' })

  const [todate1, settodate1] = useState('');
  const [toodate, settoodate] = useState('');
  const [usertype, setusertype] = useState('');
  const [branchesadmin, setbranchesadmin] = useState([]);
  const [customersData, setCustomersData] = useState([]);
  const [selectdCusID, setselectdCusID] = useState(0);
  const [selectdBranchID, setselectdBranchID] = useState('0');
  const [purchase, setpurchase] = useState([]);
  const [branchfornoadmin, setbranchfornoadmin] = useState([]);
  const [showBranch, setShowBranch] = useState(false);

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
  };
  const StatusFilterData = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Partial', value: 'Partial' },
    { label: 'Delivered', value: 'Delivered' },
    { label: 'In Transit', value: 'In Transit' },
    { label: 'All', value: 'All' },
  ];



  const changepage = () => {
    return purchase.slice(page * rowsperpage, (page + 1) * rowsperpage);
  };

  useEffect(() => {
    var date = new Date();
    var firstday = new Date(date.getFullYear(), date.getMonth(), 1);

    var lastday = new Date(
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
    );
    var lastdays = new Date(
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
    );
    getnoadminpo(firstday, lastday);
    GetCustomersByCompany();
    setfromdatee(moment(firstday).format('YYYY-MM-DD'));
    settoodate(moment(lastday).format('YYYY-MM-DD'));
    settodate1(moment(lastdays).format('YYYY-MM-DD'));

  }, []);

  const getnoadminpo = async (firstday, lastdate) => {

    const tokent = sessionStorage.getItem('authtoken');
    const type = sessionStorage.getItem('AdminUser');
    const branch = 0;
    const cuslog = 0;
    const customers = await axios.instance
      .get(
        `/GetPOStatusOnCompany/${cuslog}/${branch}/${moment(firstday).format(
          'YYYYMMDD',
        )}/${moment(lastdate).format('YYYYMMDD')}/${StatusFilter.value}/${sessionStorage.getItem('Companyid')}`,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      )
      .then(res => {
        setpurchase(res.data);
      });
  };

  const getBranchHelponCus = async cusid => {
    const tokent = sessionStorage.getItem('authtoken');
    const type = sessionStorage.getItem('AdminUser');

    const branccc = await axios.instance
      .get(`/BranchHelp/${cusid}/0/${type}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        console.log(res.data, 'cusadmin.data');
        setbranchesadmin(res.data);
        setShowBranch(true);
      });
  };

  const GetCustomersByCompany = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const companyiD = sessionStorage.getItem('Company_Id');
    const Admin = sessionStorage.getItem("AdminUser") === "Y" ? "Y" : "N";
    const Special_User1 = sessionStorage.getItem("Special_User1") === "Y" ? "Y" : "N";
    const get = await axios.instance
      .get(
        `/GetCustomerHelps/${Admin}/${Special_User1}/${sessionStorage.getItem('Companyid')}/${sessionStorage.getItem('Customer_Log') ? sessionStorage.getItem('Customer_Log') : 0}/${sessionStorage.getItem('customer_HOID') ? sessionStorage.getItem('customer_HOID') : 0}`,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      )
    setCustomersData(get.data);
  };

  const updatepagess = (id, id2, id3) => {
    history.push(`/POStatusUpdate/${id}`);
    sessionStorage.setItem('editflag', id3);
  };

  const Viewpurchase = async () => {

    const tokent = sessionStorage.getItem('authtoken');
    const customers = await axios.instance
      .get(
        `/GetPOStatusOnCompany/${selectdCusID}/${selectdBranchID}/${moment(
          fromdatee,
        ).format('YYYYMMDD')}/${moment(toodate).format('YYYYMMDD')}/${StatusFilter.value}/${sessionStorage.getItem('Companyid')}`,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      )
      .then(res => {
        setpurchase(res.data);
      });
  };

  const handleCustomerChange = e => {
    const value = e.target.value;
    setselectdCusID(value);
    getBranchHelponCus(value);
  };

  return (
    <>
      <div>
        <Card>
          <CardBody>
            <h6 className="titleviewinspectionww">Sales Order Status</h6>
            <Row className="p-3">
              <Col
              //  md={selectdCusID > 0 ? 3 : 5}>
              md={5}
              >
                <FormGroup>
                  <Label for="referenceNumber" className="font-weight-bold ">
                    Customer
                  </Label>
                  <Input
                    type="select"
                    name="status"
                    id="poStatusSelect"
                    onChange={handleCustomerChange}
                  >
                    <option selected value="0">
                      All
                    </option>
                    {customersData.map(data => (
                      <option value={data.Customer_Id}>
                        {data.Customer_Name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>

              {/* {selectdCusID > 0 && (
                <Col md={2}>
                  <FormGroup>
                    <Label for="referenceNumber" className="font-weight-bold ">
                      Branch
                    </Label>
                    <div>
                      <Input
                        type="select"
                        name="status"
                        id="poStatusSelect1"
                        onChange={e => {
                          setselectdBranchID(e.target.value);
                          console.log('branch', e.target.value);
                        }}
                      >
                        <option selected value="0">
                          All
                        </option>
                        {branchesadmin.map(data => (
                          <option key={data.Branch_Id} value={data.Branch_Id}>
                            {data.Branch_Name}
                          </option>
                        ))}
                      </Input>
                    </div>
                  </FormGroup>
                </Col>
              )} */}
              <Col md={2}>
                <FormGroup>
                  <Label for="referenceDate" className="font-weight-bold ">
                    Status
                  </Label>
                  <Select
                    defaultInputValue=""
                    options={StatusFilterData}
                    value={StatusFilter}
                    width={50}
                    onChange={value => setStatusFilter(value)}
                  />
                </FormGroup>
              </Col>
              <Col md={2}>
                <FormGroup>
                  <Label for="referenceDate" className="font-weight-bold ">
                    From Date
                  </Label>
                  <Input
                    type="date"
                    name="referenceDate"
                    id="referenceDate"
                    value={fromdatee}
                    onChange={e => setfromdatee(e.target.value)}
                  />
                </FormGroup>
              </Col>

              <Col md={2}>
                <FormGroup>
                  <Label for="referenceDate" className="font-weight-bold ">
                    To Date
                  </Label>
                  <Input
                    type="date"
                    name="referenceDate"
                    id="referenceDate"
                    value={toodate}
                    onChange={e => settoodate(e.target.value)}
                  />
                </FormGroup>
              </Col>

              <Col md={1}>
                <Button1
                  color="primary"
                  className="adbtn2"
                  style={{ marginTop: 31 }}
                  onClick={() => Viewpurchase()}
                >
                  View
                </Button1>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <div>
          <Card className="">
            <CardBody>
              <div className="Tabelinspection">
                <TableContainer>
                  <Table className="InspectionTbls">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Po No</TableCell>
                        <TableCell align="center">Po Date</TableCell>
                        <TableCell align="left">Customer Name</TableCell>
                        <TableCell align="left">Branch Name</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="center">Total Amount</TableCell>
                        <TableCell align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {purchase.length != 0 ? (
                        changepage().map(data => (
                          <TableRow key={data.Order_Id}>
                            <TableCell align="center">
                              {data.Order_No}
                            </TableCell>
                            <TableCell align="center">
                              {data.Order_Date}
                            </TableCell>
                            <TableCell style={{ textAlign: 'left' }}>
                              {data.Customer_Name}
                            </TableCell>
                            <TableCell align="left">
                              {data.Branch_Name}
                            </TableCell>
                            <TableCell
                              color="red"
                              style={{ color: '#e6f037' }}
                              align="center"
                            >
                              <Badge
                                pill
                                style={{
                                  fontSize: '13px',
                                  backgroundColor:
                                    data.Status === 'Delivered'
                                      ? '#41ef35'
                                      : data.Status === 'Partial'
                                        ? '#f0ad4e'
                                        : data.Status === 'In Transit'
                                          ? 'blue'
                                          : data.Status === 'Pending'
                                            ? 'red'
                                            : 'gray',
                                }}
                              >
                                {data.Status === 'Delivered'
                                  ? 'Delivered'
                                  : data.Status === 'Partial'
                                    ? 'Partial'
                                    : data.Status === 'Pending'
                                      ? 'Pending'
                                      : data.Status === 'In Transit'
                                        ? 'In Transit'
                                        : 'Unknown'}
                              </Badge>
                            </TableCell>

                            <TableCell style={{ textAlign: 'right' }}>
                              <b>₹</b>
                              {numeral(data.NET_AMOUNT).format('0,0.00')}
                            </TableCell>
                            <TableCell
                              align="center"
                              onClick={() =>
                                updatepagess(data.Order_Id, data.Status, 1, data.CustomerHO_Id)
                              }
                            >
                              <Button1
                                color="primary"
                                className="btn btn-sm btn-success"
                                onClick={() =>
                                  updatepagess(data.Order_Id, data.Status, 1)
                                }
                              >
                                Check & Update
                              </Button1>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableCell align="left">NO Data Found</TableCell>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TablePagination
                  component="div"
                  rowsPerPageOptions={pages}
                  count={purchase.length}
                  rowsPerPage={rowsperpage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}

export default PoStatusView;
